import { useMemo } from 'react';

import type { MenuChain } from '@/ui/components/chain-menu/types';
import useReceiveAddress from '@/ui/hooks/use-receive-address';

function isMenuChain(value: unknown): value is MenuChain {
  return value !== undefined;
}

function useMenuChains() {
  const { address: bitcoinAddress } = useReceiveAddress({
    assetName: 'bitcoin',
  });
  const { address: ethereumAddress } = useReceiveAddress({
    assetName: 'ethereum',
  });
  const { address: solanaAddress } = useReceiveAddress({
    assetName: 'solana',
  });
  return useMemo(
    () =>
      [
        bitcoinAddress && { name: 'bitcoin', address: bitcoinAddress },
        ethereumAddress && { name: 'ethereum', address: ethereumAddress },
        solanaAddress && { name: 'solana', address: solanaAddress },
      ].filter(isMenuChain),
    [bitcoinAddress, ethereumAddress, solanaAddress],
  );
}

export default useMenuChains;
